const routes = {
    path: 'dashboard',
    name: 'DashBoard',
    component: () => import('./DashBoard.vue')
};

export default routes;
